import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { getSvgStyles } from 'baseui/icon';
import { styled } from '../../../theme/utils.js';
import { Icon } from '../icon.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Svg = forwardRef((_a, ref) => {
  var _b = _a, { title, titleId } = _b, props = __objRest(_b, ["title", "titleId"]);
  return jsxs("svg", __spreadProps(__spreadValues({}, props), { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, children: [title ? jsx("title", { id: titleId, children: title }) : null, jsx("path", { fill: "currentColor", d: "M6.65325 6.12398L4.93925 7.15498C4.98925 7.23898 5.69525 8.40498 6.82125 9.92498C6.07325 10.197 5.38125 10.615 4.80225 11.194C2.64925 13.347 2.64925 16.852 4.80225 19.005C6.95525 21.158 10.4603 21.158 12.6133 19.005C13.1933 18.425 13.6103 17.734 13.8823 16.986C15.4023 18.112 16.5673 18.818 16.6523 18.868L17.6833 17.155C17.6583 17.14 15.8103 16.019 13.7543 14.355L15.0613 13.048C16.6063 13.265 18.1843 12.754 19.2893 11.648C21.2383 9.69898 21.2383 6.52598 19.2893 4.57698C17.3403 2.62798 14.1673 2.62798 12.2183 4.57698C11.1123 5.68298 10.6013 7.25998 10.8183 8.80498L9.50525 10.118C7.81325 8.03698 6.66725 6.14898 6.65225 6.12298L6.65325 6.12398ZM6.21725 17.592C4.84325 16.218 4.84325 13.983 6.21725 12.609C6.70825 12.118 7.31925 11.793 7.98325 11.655L8.56425 12.236L7.85725 12.943L10.8662 15.952L11.5733 15.245L12.1543 15.826C12.0153 16.49 11.6903 17.101 11.2003 17.592C9.82625 18.966 7.59125 18.966 6.21725 17.592ZM12.8713 8.87998C12.5933 7.82798 12.8783 6.74798 13.6333 5.99198C14.8033 4.82198 16.7063 4.82198 17.8763 5.99198C19.0463 7.16198 19.0463 9.06498 17.8763 10.235C17.1213 10.99 16.0413 11.275 14.9883 10.997L14.4323 10.85L12.2363 13.046C11.9813 12.811 11.7283 12.573 11.4823 12.326C11.2563 12.1 11.0362 11.868 10.8192 11.634L13.0173 9.43598L12.8713 8.87998Z" })] }));
});
const StyledSvg = styled(Svg, getSvgStyles);
const overrides = {
  Svg: {
    component: StyledSvg
  }
};
const IconBabyPacifier = forwardRef((props, ref) => jsx(Icon, __spreadValues({ ref, overrides }, props)));
IconBabyPacifier.displayName = "IconBabyPacifier";

export { IconBabyPacifier };
